const words = ["força", "equilíbrio", "essência", "disciplina", "ritual", "constância"];

export const Marquee = () => {
  const row = [...words, ...words];
  return (
    <div data-testid="editorial-marquee" className="w-full overflow-hidden border-y border-military/10 bg-offwhite py-6">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((w, i) => (
              <span key={`${half}-${i}`} className="font-serif italic text-4xl md:text-6xl text-military/20 mx-8 flex items-center gap-8">
                {w}
                <span className="w-2 h-2 rounded-full bg-baby border border-military/20 inline-block" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
